<template>
    <div>
        <div class="bookform">
            <v-container>
                <v-row>
                    <v-col>

                      <h1 class="mb-7" style="color: red;">К сожалению с 1 января по 30 сентября 2022 года заказы не обрабатываются.</h1>
                      <h3 style="color: red;">Планируем вернуться к отправке книг с 1 октября 2022 года.</h3>
                      <h3 class="mb-7" style="color: red;">Приносим свои извинения.</h3>
                        <h1 class="mb-7">Заказать книги серии «КНИГА-ЧАТ»
                                         <!--                            в{{'\xa0'}}РОССИЮ-->
                        </h1>
                        <p>Хотите заказать книгу серии <strong>КНИГА-ЧАТ</strong>? Результат сохранения формы
                           мы
                           получим только если вы выполните все шаги до конца и нажмете кнопку ЗАКАЗАТЬ. Спасибо. Ваши
                           данные из формы, включая указанные в
                           ней контактные данные, сохраняются у нас с целью обработки Ваших запросов и на случай
                           уточняющих
                           вопросов на ту же тему. Эти данные не передаются третьим лицам.</p>

                        <p style="font-size: 70%;">Согласие на использование предоставленных через контактную форму
                                                   данных можно в
                                                   любое
                                                   время
                                                   отозвать. Для этого обратитесь, пожалуйста, по адресу: <a
                                    href="mailto:bookaas232@gmail.com">bookaas232@gmail.com</a>.
                        </p>

                        <!--                        <p>Эта форма создана для заказов по <strong>России</strong>, <strong>Казахстану</strong>,-->
                        <!--                            <strong>Армении</strong>, <strong>Киргизии</strong>.</p>-->
                        <!--                        <p>Из Беларуси заказываем <a-->
                        <!--                                href="http://sunduchok-knig.by/shop/chat-kniga/revizor_chat-kniga/">здесь</a>.</p>-->

                        <!--                        <p>Показывать цены в </p>-->

                        <p>При заказе одной черно-белой книги цена равна <strong>29 BYN (880 RUB)</strong>.
                           При заказе одной цветной книги цена равна <strong>42 BYN (1280 RUB)</strong>.
                           От 10 книг —
                           скидка 5%.
                           От 20 книг — 10%.

                        <p>Стоимость доставки мы вам укажем в email в ответе на заказ.</p>
                        <p>Если вам необходим <strong>безналичный расчет</strong>, укажите это в примечании к заказу.
                        </p>
                        <p>Для оформления любой книги как <strong>подарка</strong> можно заказать
                            <strong>суперобложку</strong> с клапанами. На ней разместить
                            <strong>поздравление</strong>, <strong>пожелание</strong>,
                            <strong>рекламу</strong>, <strong>брэнд</strong>, <strong>слоган</strong>,
                            <strong>ваш текст</strong> или <strong>фото</strong>.
                        </p>

                        <v-card
                                class="mx-auto mt-8" shaped
                        >
                            <v-card-title class="no-word-break">
                                Выберите тип переплета, цветность и укажите количество экземпляров

                            </v-card-title>
                            <v-card-text>


                                <div class="binding">
                                    <div v-for="(bind, idx) in binds" :key="idx"
                                         :style="{borderColor : bind.reservation ? 'skyblue' : '#ddd'}"
                                         class="bind">


                                        <div class="descriptionContainer">
                                            <div class="left">

                                                <h2>{{ bind.title }}</h2>
                                                <h3>{{ bind.author }}</h3>
                                                <h4><span class="lightgray">переплет:</span> {{ bind.type }}</h4>
                                                <h4><span class="lightgray">страницы:</span> {{ bind.color }}</h4>
                                                <h4><span class="lightgray">бумага:</span> {{ bind.paper }}</h4>
                                                <h4><span class="lightgray">уголки:</span> {{ bind.corners }}</h4>
                                                <h4><span class="lightgray">наличие:</span> {{ bind.state }}</h4>

                                            </div>
                                            <div class="right">

                                                <label class="forImage">
                                                    <input class="checkbox-img" type="checkbox">
                                                    <span class="img">
                                                        <img :src="bind.src" alt="cover image" width="100%">
                                                    </span>
                                                </label>

                                                <v-switch v-model="bind.reservation" label="заказать"
                                                          @change="orderBook(idx, $event)"></v-switch>

                                                <v-text-field :ref="'input' + idx"
                                                              v-model="bind.amount"
                                                              :disabled="!bind.reservation"
                                                              :rules="kolvoRules"
                                                              label="Количество экземпляров:"
                                                              step="1"
                                                              style="width: 90%"
                                                              type="number"
                                                              @blur="changeReservation(idx, $event, $event.target)"
                                                              @change="changeReservation(idx, $event, $event.target)"
                                                              @input="changeReservation(idx, $event, $event.target)"
                                                ></v-text-field>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <!--                                <div class="binding">-->
                                <!--                                    <div class="bind">-->

                                <!--                                        <v-switch v-model="bind1" label="клеевой"></v-switch>-->

                                <!--                                        <img alt="" src="../assets/img/b1.jpg">-->

                                <!--                                        <v-text-field-->
                                <!--                                                v-model="qGlue"-->
                                <!--                                                :disabled="!bind1"-->
                                <!--                                                :rules="kolvoRules"-->
                                <!--                                                label="Сколько экземпляров в мягком переплете?"-->
                                <!--                                                step="1"-->
                                <!--                                                style="width: 90%"-->
                                <!--                                                type="number"-->
                                <!--                                        ></v-text-field>-->


                                <!--                                    </div>-->
                                <!--                                    <div class="bind">-->

                                <!--                                        <v-switch v-model="bind2" label="пружина"></v-switch>-->
                                <!--                                        <img alt="" src="../assets/img/b2.jpg">-->
                                <!--                                        <v-text-field-->
                                <!--                                                v-model="qSpring" :disabled="!bind2" :rules="kolvoRules"-->
                                <!--                                                label="Сколько экземпляров на пружине?"-->
                                <!--                                                step="1" style="width: 90%"-->
                                <!--                                                type="number"-->
                                <!--                                        ></v-text-field>-->
                                <!--                                    </div>-->
                                <!--                                </div>-->
                                <transition name="list">
                                    <v-alert v-show="totalAmount > 20"
                                             type="success">
                                        Вы заказываете более 20 книг. Мы вышлем вам на e-mail персонализированное
                                        предложение.
                                        Заполните, пожалуйста, форму до конца.
                                    </v-alert>
                                </transition>

                                <v-alert v-if="totalAmount>0" class="mt-16"
                                         type="info">

                                    <p>Заказанные книги:</p>
                                    <div v-for="(bind, idx) in binds" :key="'key' + idx">

                                        <div v-if="bind.amount">
                                            <p>
                                                <span>{{ bind.title }} </span>
                                                <span>({{ bind.type }}, </span>
                                                <span>{{ bind.color }}) — </span>
                                                <span>{{ bind.amount }} шт.</span>
                                            </p>
                                        </div>
                                    </div>

                                    <p>Итого книг: {{ totalAmount }}</p>
                                    <p>Заполните, пожалуйста, форму до конца.</p>
                                </v-alert>
                            </v-card-text>

                        </v-card>

                        <!--                        <v-card :disabled="!totalAmount" class="mx-auto mt-8" shaped>-->
                        <!--                            <v-card-title>-->
                        <!--                                Город доставки-->
                        <!--                            </v-card-title>-->
                        <!--                            <v-card-text>-->
                        <!--                                <v-radio-group v-model="city">-->
                        <!--                                    <v-radio label="Минск" value="minskCity" @click="clearPostMethod"></v-radio>-->
                        <!--                                    <v-radio label="Москва" value="moscowCity" @click="clearPostMethod"></v-radio>-->
                        <!--                                    <v-radio label="Санкт-Петербург" value="piterCity" @click="clearPostMethod"></v-radio>-->
                        <!--                                    <v-radio label="Екатеринбург" value="sverdlovskCity" @click="clearPostMethod"></v-radio>-->
                        <!--                                    <v-radio label="Другой" value="otherCity" @click="clearPostMethod"></v-radio>-->
                        <!--                                </v-radio-group>-->
                        <!--                                &lt;!&ndash;                                <v-text-field v-if="city==='otherCity'" v-model="otherCity"&ndash;&gt;-->
                        <!--                                &lt;!&ndash;                                              placeholder="Укажите название города"></v-text-field>&ndash;&gt;-->
                        <!--                            </v-card-text>-->
                        <!--                        </v-card>-->

                        <v-card class="mx-auto mt-8" shaped>
                            <v-card-title>
                                Доставка
                            </v-card-title>
                            <v-card-text>
                                Мы подберем вам самый оптимальный вариант доставки, в зависимости от адреса доставки и
                                веса посылки. Доставка в Россию осуществляется СДЭКом или Белпочтой.
                                Доставка по Беларуси — Европочта или Белпочта наложенным платежом. Доставка в другие
                                страны мира — Белпочта.
                                <!--                                <v-radio-group v-model="postMethod">-->
                                <!--                                    <v-radio v-if="city==='moscowCity'" label="самовывоз с ВДНХ. Бесплатно"-->
                                <!--                                             value="samovyvozVDNH" @click="clearPaymentMethod"></v-radio>-->
                                <!--                                    <v-radio-->
                                <!--                                            label="СДЭК из Минска. В зависимости от расстояния стоимость доставки от 350 RUB"-->
                                <!--                                            value="SDEKfromMinsk" @click="clearPaymentMethod"></v-radio>-->
                                <!--                                    <v-radio v-if="city!=='moscowCity'"-->
                                <!--                                             label="почта из Минска. Стоимость доставки от 770 RUB"-->
                                <!--                                             value="postFromMinsk" @click="clearPaymentMethod"></v-radio>-->
                                <!--                                </v-radio-group>-->
                            </v-card-text>
                        </v-card>

                        <v-card class="mx-auto mt-8" shaped>
                            <v-card-title>
                                Оплата
                            </v-card-title>
                            <v-card-text>
                                В большинстве случаев книгу можно будет оплатить банковской картой или наличными при
                                получении.
                                <!--                                <v-radio-group v-model="paymentMethod">-->
                                <!--                                    <v-radio v-if="postMethod!=='samovyvozVDNH'"-->
                                <!--                                             label="оплата при получении книги"-->
                                <!--                                             value="oplataSDEK"></v-radio>-->
                                <!--                                    <v-radio v-if="postMethod!=='samovyvozVDNH'"-->
                                <!--                                             label="оплата картой. Все заказы можно оплатить картой"-->
                                <!--                                             value="oplataKartoj"></v-radio>-->
                                <!--                                    <v-radio-->
                                <!--                                            v-if="postMethod==='samovyvozVDNH'"-->
                                <!--                                            label="наличные. (Только при самовывозе с ВДНХ)"-->
                                <!--                                            value="nalichnye"></v-radio>-->

                                <!--                                </v-radio-group>-->
                            </v-card-text>
                        </v-card>

                        <v-card class="mx-auto mt-8" shaped>
                            <v-card-title>
                                <!--                                Итого к оплате около {{ summa }} RUB (или {{ Math.ceil(summa / RUBBYNkurs) }} BYN)-->
                                Ваш адрес
                            </v-card-title>
                            <v-card-text>
                                <v-text-field v-if="postMethod!=='samovyvozVDNH'"
                                              v-model="address"
                                              :rules="requireRule" label="Укажите ваш почтовый адрес (с индексом)"
                                              outlined></v-text-field>
                                <v-text-field v-model="email" :rules="emailRule" label="Укажите ваш e-mail"
                                              outlined></v-text-field>
                                <v-checkbox v-model="subscribe" label="Получать новости серии «КНИГА-ЧАТ?»">

                                </v-checkbox>
                            </v-card-text>
                        </v-card>

                        <v-card class="mx-auto mt-8"
                                shaped>
                            <v-card-title class="no-word-break">
                                Фамилия, имя, отчество и номер телефона обязательны для отправки по почте.
                            </v-card-title>
                            <v-card-text>
                                <v-text-field v-model="name" :rules="requireRule"
                                              label="Фамилия Имя Отчество" outlined></v-text-field>
                                <v-text-field v-model="phone" :rules="requireRule" label="Укажите ваш мобильный телефон"
                                              outlined></v-text-field>

                            </v-card-text>
                        </v-card>

                        <v-card class="mx-auto mt-8"
                                shaped>
                            <v-card-title class="no-word-break">
                                Примечание
                            </v-card-title>
                            <v-card-text>
                                <v-text-field
                                        v-model="primechanie" label="ваше примечание к заказу" outlined></v-text-field>
                            </v-card-text>
                        </v-card>

                        <v-card class="mx-auto mt-8"
                                shaped>
                            <v-card-title class="no-word-break">
                                Промокод
                            </v-card-title>
                            <v-card-text>
                                <v-text-field
                                        v-model="promokod" label="введите промокод" outlined></v-text-field>
                            </v-card-text>
                        </v-card>

                        <v-btn :disabled="!enableOrderButton" block class="primary mx-auto mt-8"
                               shaped style="margin-bottom: 40px;" x-large @click="makeOrder">
                            ЗАКАЗАТЬ
                        </v-btn>

                    </v-col>
                </v-row>

            </v-container>
        </div>
        <!--        <v-system-bar color="primary" dark-->
        <!--                      window>-->
        <!--            <v-spacer></v-spacer>-->

        <!--            <span>Итого к оплате {{ summa }} RUB (или {{ Math.ceil(summa / RUBBYNkurs) }} BYN)</span>-->
        <!--            <v-spacer></v-spacer>-->
        <!--        </v-system-bar>-->

        <v-system-bar
                window>
            <v-spacer></v-spacer>

            <small>© 2020–{{ (new Date).getFullYear()}}
                <a href="https://www.facebook.com/kanstantsin.strausau"
                   target="_blank">Kanstantsin Strausau</a></small>
            <v-spacer></v-spacer>
        </v-system-bar>

    </div>
</template>

<script>
import fb from 'firebase';

export default {
    name: "OrderBook",
    data: () => ({
        binds: [
            {
                title: 'РЕВИЗОР',
                author: 'Н. В. Гоголь',
                type: 'клеевой',
                reservation: false,
                amount: 0,
                color: '264, черно-белые (1+1)',
                paper: 'офсетная',
                corners: 'обычные',
                state: 'доступна',
                src: 'images/b1.jpg',
            },
            {
                title: 'РЕВИЗОР',
                author: 'Н. В. Гоголь',
                type: 'пружинный',
                reservation: false,
                amount: 0,
                paper: 'офсетная',
                corners: 'скругленные',
                color: '264, черно-белые (1+1)',
                state: 'доступна',
                src: 'images/b2.jpg',
            },
            {
                title: 'ГОРЕ ОТ УМА',
                author: 'А. С. Грибоедов',
                type: 'клеевой',
                reservation: false,
                amount: 0,
                color: '272, черно-белые (1+1)',
                paper: 'офсетная',
                corners: 'обычные',
                state: 'доступна',
                src: 'images/g1.jpg',
            },
            {
                title: 'ГОРЕ ОТ УМА',
                author: 'А. С. Грибоедов',
                type: 'клеевой',
                reservation: false,
                amount: 0,
                color: '272, полноцветные (4+4)',
                paper: 'мелованная',
                corners: 'обычные',
                state: 'доступна',
                src: 'images/g1.jpg',
            },
            {
                title: 'ГОРЕ ОТ УМА',
                author: 'А. С. Грибоедов',
                type: 'пружинный',
                reservation: false,
                amount: 0,
                color: '272, черно-белые (1+1)',
                paper: 'офсетная',
                corners: 'скругленные',
                state: 'доступна',
                src: 'images/g2.jpg',
            },
            {
                title: 'ГОРЕ ОТ УМА',
                author: 'А. С. Грибоедов',
                type: 'пружинный',
                reservation: false,
                amount: 0,
                color: '272, полноцветные (4+4)',
                paper: 'мелованная',
                corners: 'скругленные',
                state: 'доступна',
                src: 'images/g2.jpg',
            },
            // {
            //     title: 'Суперобложка',
            //     author: 'для книги «РЕВИЗОР» или «ГОРЕ ОТ УМА» с клеевым переплетом',
            //     type: 'глянцевый ламинат',
            //     reservation: false,
            //     amount: 0,
            //     color: 'полноцветная (4+0)',
            //     paper: 'мелованная',
            //     corners: 'обычные',
            //     state: 'под заказ, подробности вышлем на e-mail',
            //     src: 'images/super1.jpg',
            // },
            // {
            //     title: 'Суперобложка',
            //     author: 'для любых других ваших книг',
            //     type: 'глянцевый ламинат',
            //     reservation: false,
            //     amount: 0,
            //     color: 'полноцветная (4+0)',
            //     paper: 'мелованная',
            //     corners: 'обычные',
            //     state: 'под заказ, подробности вышлем на e-mail',
            //     src: 'images/super2.jpg',
            // },
        ],


        bind1: false,
        bind2: false,
        requireRule: [
            v => !!v || 'Укажите значение!',
        ],
        kolvoRules: [
            v => !!v || 'Укажите значение!',
            v => v > 0 || 'Укажите значение > 0',
        ],
        emailRule: [
            v => !!v || 'Укажите значение!',
            value => {
                if (value.length > 0) {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || 'Invalid e-mail.';
                } else return false;
            }
        ],
        qGlue: 1,
        qSpring: 1,
        city: '',
        otherCity: '',
        postMethod: '',
        paymentMethod: '',
        subscribe: true,
        email: '',
        address: '',
        // enableOrderButton: true,
        name: '',
        phone: '',
        primechanie: '',
        promokod: '',
        RUBBYNkurs: 29,
    }),
    computed: {
        totalAmount() {
            return this.binds.reduce((acc, el) => el.reservation ? acc + parseInt(el.amount) : acc, 0);
        },

        totalQ: function () {
            return (this.bind1 ? parseInt(this.qGlue) : 0) + (this.bind2 ? parseInt(this.qSpring) : 0)
        },

        priceOne: function () {
            let res = 880;
            if (this.totalQ > 9) res = 840;
            if (this.totalQ > 19) res = 800;
            return res;
        },
        post: function () {
            let postRes = 330;

            if (this.totalQ > 1) postRes = 380;
            if (this.totalQ > 2) postRes = 420;
            if (this.totalQ > 3) postRes = 460;
            if (this.totalQ > 4) postRes = 500;
            if (this.totalQ > 5) postRes = 540;
            if (this.totalQ > 7) postRes = 580;
            if (this.totalQ > 9) postRes = 620;
            if (this.totalQ > 12) postRes = 700;
            if (this.totalQ > 14) postRes = 750;
            if (this.totalQ > 16) postRes = 800;
            if (this.totalQ > 18) postRes = 870;
            if (this.totalQ > 20) postRes = 940;

            if (this.postMethod === 'samovyvozVDNH' || this.totalQ === 0 || !this.postMethod) postRes = 0;

            return postRes;
        },
        summa: function () {
            return this.totalQ * this.priceOne + this.post;
        },
        checkEmail: function () {
            return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.email)
        },

        enableOrderButton: function () {
            return this.totalAmount && this.address && this.checkEmail && this.name && this.phone
        }


    },
    methods: {

        orderBook(idx) {
            console.log('bbb', idx);
            console.log(this.$refs['input' + idx]);
            if (this.binds[idx].reservation) {
                this.binds[idx].amount = 1;
                setTimeout(() => {
                    this.$refs['input' + idx][0].$el.querySelector('input').focus();
                    // this.$refs['input' + idx][0].$el.querySelector('input').select();
                }, 1000);
            } else {
                this.binds[idx].amount = 0;
            }
        },

        changeReservation(idx) {
            console.log('changeReservation');
            console.log(arguments);
            console.log(idx);
            if (this.binds[idx].amount == 0) this.binds[idx].reservation = false
        },


        async makeOrder() {
            console.log('make order');
            // let response = await fetch('https://134.209.229.131:8082/saveOrder', {
            //     method: 'POST',
            //     cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            //     body: JSON.stringify({
            //         bind1: this.bind1,
            //         bind2: this.bind2,
            //         qGlue: this.qGlue,
            //         qSpring: this.qSpring,
            //         city: this.city,
            //         otherCity: this.otherCity,
            //         postMethod: this.postMethod,
            //         paymentMethod: this.paymentMethod,
            //         subscribe: this.subscribe,
            //         email: this.email,
            //         address: this.address,
            //     })
            // });
            // let result = await response.json();
            // console.log(result);


            console.log('saveData');

            let time = String(+new Date())

            fb.firestore().collection('bookOrders').doc(time).set({
                data: {
                    // bind1: this.bind1,
                    binds: this.binds,
                    // bind2: this.bind2,
                    // qGlue: this.bind1 ? this.qGlue : 0,
                    // qSpring: this.bind2 ? this.qSpring : 0,
                    // city: this.city,
                    // otherCity: this.otherCity,
                    // postMethod: this.postMethod,
                    // paymentMethod: this.paymentMethod,
                    subscribe: this.subscribe,
                    email: this.email,
                    address: this.address,
                    name: this.name,
                    phone: this.phone,
                    orderTime: new Date().toLocaleString(),
                    primechanie: this.primechanie,
                    promokod: this.promokod
                },
                dateTime: time
            }, {merge: false}).then(() => {

                alert('Спасибо! Ваш заказ принят. Мы свяжемся с вами по электронной почте.');
                location.href = 'https://chat-book.by';

            }).catch(err => {
                console.error(err);
                alert('ОШИБКА! Что пошло не так! ' + err);
            });
        },
        clearPostMethod() {
            this.postMethod = '';
        },
        clearPaymentMethod() {
            this.paymentMethod = '';
        }


    }
}
</script>

<style lang="scss" scoped>

.lightgray {
    color: #bbb;
}

.descriptionContainer {
    display: grid;
    grid-template-columns: 2fr 1fr;
}

h2 {
    margin-top: 16px;
}

h3 {
    margin-top: 6px;
}

h4 {
    margin-top: 6px;
}

.bookform {
    text-align: left;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
}

.binding {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 30px;
    grid-row-gap: 70px;
}

.bind {
    padding: 30px;
    border: 2px solid skyblue;

    border-radius: 8px;
}

.binding img {
    width: 100%;
}

.descriptionContainer {
    grid-column-gap: 20px;
}


@media (max-width: 800px) {

    .descriptionContainer {
        grid-template-columns: 1fr;
    }
    .binding img {
        margin-top: 20px;
    }

}


@media (max-width: 640px) {

    .binding {
        grid-template-columns: 1fr;
        grid-column-gap: 30px;
        grid-row-gap: 20px;
    }


    .bind {
        padding: 16px;
    }
}


.no-word-break {
    word-break: normal;
}


.list-enter,
.list-leave-to {
    visibility: hidden;
    height: 0;
    margin: 0;
    padding: 0;
    opacity: 0;
}

.list-enter-active,
.list-leave-active {
    transition: all 0.3s;
}

.v-system-bar--window {
    top: inherit;
    bottom: 0;
    position: fixed;
    width: 100%;
    height: 20px;
}

</style>

<style>

.right .v-input input {
    font-size: 52px !important;
    padding: 8px !important;
    max-height: 60px !important;
}

.checkbox-img {
    display: none;
}

.checkbox-img + .img {
    cursor: pointer;
}

.checkbox-img:checked + .img {
    width: 100vw;
    position: fixed;
    top: 0;
    height: 100vh;
    left: 0;
    z-index: 100;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

/*.forImage {*/
/*    position: relative;*/
/*}*/

</style>
